module.exports = __webpack_public_path__ + "static/media/monadnock.1643c871.jpeg";